import { Box, Button, Flex, Text, Title } from "@mantine/core";
import offlineImageSrc from "@/assets/offline-state.png?inline";

const OfflinePage = () => {
  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <Flex direction="column" justify="center" align="center" h="100vh" px="md" bg="#f8fafc">
      <Flex direction="column" justify="center" align="center" gap="md" maw={560}>
        <Box w={320} style={{ overflow: "hidden" }}>
          <img
            src={offlineImageSrc}
            alt="Offline connection illustration"
            style={{
              display: "block",
              width: "100%",
              transform: "scale(1.015)",
              transformOrigin: "center",
              mixBlendMode: "multiply",
            }}
          />
        </Box>

        <Title order={2} c="#1e293b" ta="center">
          You&apos;re offline
        </Title>

        <Text c="#64748b" ta="center">
          It looks like your internet connection is down. Please check your network and try again.
        </Text>

        <Button variant="light" onClick={refreshPage}>
          Try again
        </Button>
      </Flex>
    </Flex>
  );
};

export default OfflinePage;
